import { render, staticRenderFns } from "./parentingCalen.vue?vue&type=template&id=c036bb1a&scoped=true"
import script from "./parentingCalen.vue?vue&type=script&lang=js"
export * from "./parentingCalen.vue?vue&type=script&lang=js"
import style0 from "./parentingCalen.vue?vue&type=style&index=0&id=c036bb1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c036bb1a",
  null
  
)

export default component.exports